import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ICreateIntegrationModalProps } from '@app/dashboard/types/innerLayout/payment_integrations/create-integrations';
import type { ICreateIntegrationModal } from '@app/dashboard/types/innerLayout/payment_integrations/create-integrations';
import { Modal, StatusIndicator } from '@unified-checkout/design-system';
import { Check, Xmark } from '@unified-checkout/design-system/icons/index';
import { IButton } from 'libs/design-system/src/types/Button/button';
import { CreateIntegration } from '../body';

export const CreateIntegrationModal = ({
  open,
  selectedPaymentType,
  selectedCurrency,
  isShopify,
  processedCallback,
  responseCallback,
  createIntegrationPending,
  allowedCountryGateways,
  response,
  responseStatus,
  responseMessage,
  onClose,
  onSubmit,
  onResponseClose,
  getPaymentTypeOptions,
  getAvailableCurrencies,
  onPlatformChange,
  onPaymentTypeChange,
  onCurrencyChange,
  onProcessedCallbackChange,
  onResponseCallbackChange,
}: ICreateIntegrationModalProps) => {

  const { t } = useTranslation();
  const isResponseMode = response && responseStatus;

  const title = isResponseMode ?
    ''
    :
    t('innerLayout.paymentIntegrationsPage.table.headers.paymentIntegration.createIntegrations');

  const position = isResponseMode ?
    "default"
    :
    "center"

  const onCloseAction = isResponseMode ?
    onResponseClose
    :
    onClose

  const btns = isResponseMode ?
    undefined
    :
    [
      {
        color: 'primary',
        text: t('innerLayout.paymentIntegrationsPage.table.headers.paymentIntegration.submit'),
        onClickHandler: onSubmit,
        loading: createIntegrationPending,
        disabled: !selectedPaymentType || !selectedCurrency || (!!processedCallback && !responseCallback) || (!!responseCallback && !processedCallback),
      } as IButton,
      {
        color: 'secondary',
        text: t('innerLayout.paymentIntegrationsPage.table.headers.modal.cancel'),
        variant: 'outlined',
        onClickHandler: onClose,
        disabled: createIntegrationPending,
      } as IButton,
    ];

  const status = responseStatus === 'success' ?
    <StatusIndicator
      status="success"
      icon={Check}
      hintText={t('innerLayout.paymentIntegrationsPage.table.headers.paymentIntegration.succesAddpayment')}
    />
    :
    responseStatus === 'error' ?
      <StatusIndicator
        status="error"
        icon={Xmark}
        hintText={responseMessage ?
          responseMessage
          :
          t('innerLayout.paymentIntegrationsPage.table.headers.paymentIntegration.faildAddpayment')}
      />
      :
      null

  const createIntegrationProps = {
    open,
    paymentTypeOptions: getPaymentTypeOptions(),
    currencyOptions: getAvailableCurrencies(),
    selectedPlatform: isShopify ? 'shopify' : 'non_shopify',
    selectedPaymentType,
    selectedCurrency,
    onPlatformChange,
    onPaymentTypeChange,
    onCurrencyChange,
    processedCallbackValue: processedCallback,
    responseCallbackValue: responseCallback,
    onProcessedCallbackChange,
    onResponseCallbackChange,
    isOnboarding: allowedCountryGateways?.PAYPAL?.is_onboarding,
    onboardingStatus: allowedCountryGateways?.PAYPAL?.onboarding_status,
  };


  const modalProps: ICreateIntegrationModal = {
    state: "default",
    open,
    position: position,
    title: title,
    onCloseHandler: onCloseAction,
    btnsProps: btns,
    hasCloseIcon: true,
  };

  return (
    <Modal
      key={open ? 'create-integration-open' : 'create-integration-closed'}
      {...modalProps}
    >
      {isResponseMode ? status : <CreateIntegration {...createIntegrationProps} />}
    </Modal>
  );
};
